export default function EmptyChat() {
  return (
    <div className="flex flex-1 justify-center items-center h-full">
      <img src="/assets/chat/emptyChat.svg" alt="searchIcon" />
    </div>
  )
}
